module.exports = __webpack_public_path__ + "static/media/logo.82ee2b5e.png";